module.exports = "/images/pause.svg?30ff003ceeea167b5409daf18ea3ad1b";